<template>
  <div class="info-about-insurance">
    <span>{{ $t("carriers.modalInfo.insurance") }}</span>
    <p v-if="displayInsuranceValue">
      Insured, cargo value: {{ displayInsuranceValue }}
      <b><i>{{ $t("carriers.messageVendorInsurance") }} </i></b>
    </p>
    <p v-else>Up to Cargo Value $25000</p>
  </div>
</template>

<script>
export default {
  name: "InfoAboutInsurance",
  props: {
    displayInsuranceValue: [String, Number],
  },
};
</script>

<style lang="scss" scoped>
.info-about-insurance {
  span {
    font-weight: bold;
  }
  p {
    margin: 0px;
  }
}
</style>
